var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn"},[_c('p',[_vm._v("This reference is also available from within the editor.")]),_c('reference-x1')],1)}
var staticRenderFns = []

export { render, staticRenderFns }